// wishlistDrawerReducer.js
const initialState = {
  wishlistDrawer: false,
};

export const wishlistDrawerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "WISHLIST_DRAWER":
      return { ...state, wishlistDrawer: action.payload };
    default:
      return state;
  }
};
